module.exports = __webpack_public_path__ + "static/media/CACAO_03.d38b84c4.png";